import { useEffect, useState } from 'react';

const useDebouncedSearch = (ms = 1000) => {
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState(undefined);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearch(search || undefined);
    }, ms);
    return () => clearTimeout(timeoutId);
  }, [search]);
  return [search, setSearch, debouncedSearch];
};

export default useDebouncedSearch;
